import './color-picker.scss';

import * as gzColorPickerDirective from './color-picker.directive';

export default angular.module('gazelle.components.colorPicker', [
  'ngMaterial',
  'pascalprecht.translate',
  'ngSanitize'
])
  .directive(gzColorPickerDirective.name, gzColorPickerDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/color-picker/color-picker.module.js